const doc = [];
module.exports = doc.length <= 1 ? doc[0] : doc;